import { Queue } from './Queue';
import { Devices } from './Devices';
import { Details } from './Details';
// Redux
import { memo, useEffect } from 'react';
import { fetchDevices } from '../../../../store/slices/spotify';
import { useAppDispatch, useAppSelector } from '../../../../store/store';

import { AnimatePresence, motion } from 'framer-motion';
import { useRef } from 'react';

export const PlayingNow = memo(() => {
  const dispatch = useAppDispatch();

  const currentSong = useAppSelector(
    (state) => state.spotify.state?.track_window.current_track,
    (a, b) => a?.id === b?.id
  );

  const queue = useAppSelector((state) => !state.ui.queueCollapsed);
  const details = useAppSelector((state) => !state.ui.detailsCollapsed);
  const devices = useAppSelector((state) => !state.ui.devicesCollapsed);

  useEffect(() => {
    const interval = setTimeout(() => {
      dispatch(fetchDevices());
    }, 1000);

    return () => clearTimeout(interval);
  }, [currentSong?.id, dispatch]);

  const wasDetailsExpandedRef = useRef(details);

  if (!queue && !devices) {
    wasDetailsExpandedRef.current = details;
  }

  if (devices) {
    return (
      <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden', borderRadius: 8 }}>
        <Devices />
      </div>
    );
  }
  
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden', borderRadius: 8 }}>
      <div style={{ width: '100%', height: '100%' }}>
        <Details collapsed={!details && !queue && !devices} />
      </div>

      <AnimatePresence>
        {queue && (
          <motion.div
            key="queue-overlay"
            initial={wasDetailsExpandedRef.current ? { y: '100%' } : { y: 0, opacity: 0 }}
            animate={wasDetailsExpandedRef.current ? { y: 0 } : { y: 0, opacity: 1 }}
            exit={wasDetailsExpandedRef.current ? { y: '100%' } : { opacity: 0, transition: { duration: 0.2 } }}
            transition={{ type: 'tween', duration: 0.4, ease: [0.4, 0, 0.2, 1] }}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              zIndex: 10,
              backgroundColor: '#121212',
              borderRadius: 8,
              overflow: 'hidden',
            }}
          >
            <Queue />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
});
